import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_ThoughtsAdult = ({ itemsRef, showErrorFor }) => {

   return (
      <form id='NBT_ThoughtsAdult' className='file-pdf-document'>
         <div className='file-template'>

            <h3>
               LEVEL 2-Repetitive Thoughts and Behaviors-Adult*
            </h3>
            <h3>
               *Adapted from the Florida Obsessive-Compulsive Inventory (FOCI) Severity Scale (Part B)
            </h3>
            <table>
               <tr>
                  <td className="w-375">
                     <span className="eleHeader">Name:</span>
                     <input type="text" id="txtChild11" name="txtChild11" className="add-only" />
                  </td>
                  <td className="w-375">
                     <span className="eleHeader">Age:</span>
                     <input type="text" id="txtAge" name="txtAge" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <span className="eleHeader">Sex:</span>
                     <input type="radio" id="rbPregnancy_Yes" name="rbPregnancy" className="add-only" value="1" /> Male
                     &nbsp;
                     <input type="radio" id="rbPregnancy_No" name="rbPregnancy" className="add-only" value="0" /> Female

                  </td>
                  <td className="w-375">
                     <span className="eleHeader">Date:</span>
                     <input type="date" id="txtDate" name="txtDate" className="add-only" />
                  </td>

               </tr>


            </table>
            <p>
               If the measure is being completed by an informant, what is your relationship with the individual receiving care?
               <input type="text" id="txtChild" name="txtChild" className="add-only" />
            </p>
            <p>
               In a typical week, approximately how much time do you spend with the individual receiving care?
               <input type="text" id="txtChild1" name="txtChild1" className="add-only" /> hours/week
            </p>
            <p>
               <strong>Instructions:</strong> On the DSM-5 Level 1 cross-cutting questionnaire that you just completed, you indicated that during the past 2
               weeks you have been bothered by "unwanted repeated thoughts, images, or urges" and/or "being driven to perform certain
               behaviors or mental acts over and over" at a mild or greater level of severity. The questions below ask about these feelings in
               more detail and especially how often you have been bothered by a list of symptoms during the past 7 days. Please respond to
               each item by marking (&#10003; or x) one box per row.
            </p>
            <p>
               <b>
                  0-None <br />
                  1-Mild (Less than an hour a day) <br />
                  2-Moderate (1 to 3 hours a day) <br />
                  3-Severe (3 to 8 hours a day) <br />
                  4-Extreme (more than 8 hours a day)
               </b>
            </p>
            <table>
               <tr>
                  <td className="w-650">
                     <span className="eleHeader">During the past SEVEN (7) DAYS...</span>
                  </td>
                  <td className="w-100">
                     <span className="eleHeader">Clinician Use<br />Item Score</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-300"> &nbsp;</td>
                  <td className="w-60"><b> 0-None </b></td>
                  <td className="w-60"><b> 1-Mild </b> </td>
                  <td className="w-90"><b> 2-Moderate </b> </td>
                  <td className="w-75"><b> 3-Severe </b> </td>
                  <td className="w-75"><b> 4-Extreme </b>  </td>
                  <td className="w-100"> &nbsp;</td>
               </tr>
               <tr>
                  <td className="w-300">
                     1. On average, how much time is occupied by these thoughts or behaviors each day?
                  </td>
                  <td className="w-60 text-center">
                     <input type="radio" id="rbSlight_Yes" name="rbSlight" className="add-only" value="1" /> 0
                  </td>
                  <td className="w-60 text-center">
                     <input type="radio" id="rbSlight_No" name="rbSlight" className="add-only" value="2" /> 1
                  </td>
                  <td className="w-90 text-center">
                     <input type="radio" id="rbSlight_Np" name="rbSlight" className="add-only" value="3" /> 2
                  </td>
                  <td className="w-75 text-center">
                     <input type="radio" id="rbSlight_Nc" name="rbSlight" className="add-only" value="4" /> 3
                  </td>
                  <td className="w-75 text-center">
                     <input type="radio" id="rbSlight_Nd" name="rbSlight" className="add-only" value="5" /> 4
                  </td>
                  <td className="w-100">
                     <input type="text" id="txtDomain" name="txtDomain" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-300">
                     2. How much distress do these thoughts or behaviors cause you?
                  </td>
                  <td className="w-60 text-center">
                     <input type="radio" id="rbSlight1_Yes" name="rbSlight1" className="add-only" value="1" /> 0
                  </td>
                  <td className="w-60 text-center">
                     <input type="radio" id="rbSlight1_No" name="rbSlight1" className="add-only" value="2" /> 1
                  </td>
                  <td className="w-90 text-center">
                     <input type="radio" id="rbSlight1_Np" name="rbSlight1" className="add-only" value="3" /> 2
                  </td>
                  <td className="w-75 text-center">
                     <input type="radio" id="rbSlight1_Nc" name="rbSlight1" className="add-only" value="4" /> 3
                  </td>
                  <td className="w-75 text-center">
                     <input type="radio" id="rbSlight1_Nd" name="rbSlight1" className="add-only" value="5" /> 4
                  </td>
                  <td className="w-100">
                     <input type="text" id="txtDomain1" name="txtDomain1" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-300">
                     3. How hard is it for you to control these thoughts or behaviors?
                  </td>
                  <td className="w-60 text-center">
                     <input type="radio" id="rbSlight2_Yes" name="rbSlight2" className="add-only" value="1" /> 0
                  </td>
                  <td className="w-60 text-center">
                     <input type="radio" id="rbSlight2_No" name="rbSlight2" className="add-only" value="2" /> 1
                  </td>
                  <td className="w-90 text-center">
                     <input type="radio" id="rbSlight2_Np" name="rbSlight2" className="add-only" value="3" /> 2
                  </td>
                  <td className="w-75 text-center">
                     <input type="radio" id="rbSlight2_Nc" name="rbSlight2" className="add-only" value="4" /> 3
                  </td>
                  <td className="w-75 text-center">
                     <input type="radio" id="rbSlight2_Nd" name="rbSlight2" className="add-only" value="5" /> 4
                  </td>
                  <td className="w-100">
                     <input type="text" id="txtDomain2" name="txtDomain2" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-300">
                     4. How much do these thoughts or behaviors cause you to avoid doing anything, going anyplace, or being with anyone?
                  </td>
                  <td className="w-60 text-center">
                     <input type="radio" id="rbSlight3_Yes" name="rbSlight3" className="add-only" value="1" /> 0
                  </td>
                  <td className="w-60 text-center">
                     <input type="radio" id="rbSlight3_No" name="rbSlight3" className="add-only" value="2" /> 1
                  </td>
                  <td className="w-90 text-center">
                     <input type="radio" id="rbSlight3_Np" name="rbSlight3" className="add-only" value="3" /> 2
                  </td>
                  <td className="w-75 text-center">
                     <input type="radio" id="rbSlight3_Nc" name="rbSlight3" className="add-only" value="4" /> 3
                  </td>
                  <td className="w-75 text-center">
                     <input type="radio" id="rbSlight3_Nd" name="rbSlight3" className="add-only" value="5" /> 4
                  </td>
                  <td className="w-100">
                     <input type="text" id="txtDomain3" name="txtDomain3" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-300">
                     5. How much do these thoughts or behaviors interfere with school, work, or your social or family life?
                  </td>
                  <td className="w-60 text-center">
                     <input type="radio" id="rbSlight4_Yes" name="rbSlight4" className="add-only" value="1" /> 0
                  </td>
                  <td className="w-60 text-center">
                     <input type="radio" id="rbSlight4_No" name="rbSlight4" className="add-only" value="2" /> 1
                  </td>
                  <td className="w-90 text-center">
                     <input type="radio" id="rbSlight4_Np" name="rbSlight4" className="add-only" value="3" /> 2
                  </td>
                  <td className="w-75 text-center">
                     <input type="radio" id="rbSlight4_Nc" name="rbSlight4" className="add-only" value="4" /> 3
                  </td>
                  <td className="w-75 text-center">
                     <input type="radio" id="rbSlight4_Nd" name="rbSlight4" className="add-only" value="5" /> 4
                  </td>
                  <td className="w-100">
                     <input type="text" id="txtDomain4" name="txtDomain4" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-600 text-right">
                     <strong>Total/Partial Raw Score:</strong>
                  </td>
                  <td className="w-150">
                     <input type="text" id="txtDomain11" name="txtDomain11" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-600 text-right">
                     <strong>Prorated Total Raw Score (if 1 item is left unanswered):</strong>
                  </td>
                  <td className="w-150">
                     <input type="text" id="txtDomain12" name="txtDomain12" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-600 text-right">
                     <strong>Average Total Score:</strong>
                  </td>
                  <td className="w-150">
                     <input type="text" id="txtDomain13" name="txtDomain13" className="add-only" />
                  </td>
               </tr>
            </table>
            <p>
               <strong>Instructions to Clinicians</strong>
            </p>
            <p>
               The DSM-5 Level 2-Repetitive Thoughts and Behavior-Adult measure is an adapted version of the 5-item
               Florida Obsessive-Compulsive Inventory (FOCI) Severity Scale (Part B) that is used to assess the domain of
               repetitive thoughts and behaviors in individuals age 18 and older. The measure is completed by an individual
               prior to a visit with the clinician. If the individual receiving care is of impaired capacity and unable to complete
               the form (e.g., an individual with dementia), a knowledgeable informant may complete the measure. Each
               item asks the individual (or informant) to rate the severity of the individual's repetitive thoughts and behaviors
               during the past 7 days.
            </p>
            <p>
               <strong>Scoring and Interpretation</strong>
            </p>
            <p>
               Each item on the measure is rated on a 5-point scale (i.e., 0 to 4) with the response categories having different
               anchors depending on the item. The total score for the measure can range of score from 0 to 20, with higher
               scores indicating greater severity of repetitive thoughts and behaviors. The clinician is asked to review the
               score of each item on the measure during the clinical interview and indicate the raw score for each item in the
               section provided for "Clinician Use." The raw scores on the 5 items should be summed to obtain a total raw
               score. If the individual has a score of 8 or higher, you may want to consider a more detailed assessment for an
               obsessive compulsive disorder. In addition, the clinician is asked to calculate and use the average total score.
               The average total score reduces the overall score to a 5-point scale, which allows the clinician to think of the
               individual's repetitive thoughts and behavior in terms of none (0), mild (1), moderate (2), severe (3), or
               extreme (4). The use of the average total score was found to be reliable, easy to use, and clinically useful to the
               clinicians in the DSM-5 Field Trials. The average total score is calculated by dividing the raw total score by
               number of items in the measure (i.e., 5).
               on the measure.
            </p>
            <p>
               <strong>Note:</strong>
            </p>
            <p>
               If 2 or more items are left unanswered on the measure (i.e., more than 25% of the total items are
               missing), the total scores should not be calculated. Therefore, the individual (or informant) should be
               encouraged to complete all of the items on the measure. If only 4 of the 5 items on the measure are answered,
               you are asked to prorate the raw score by first summing the scores of items that were answered to get a
               partial raw score. Next, multiply the partial raw score by the total number of items on the measure (i.e., 5).
               Finally, divide the value by the number of items that were actually answered (i.e., 4) to obtain the prorated
               total raw score.
            </p>
            <p>
               Prorated Score =(Partial Raw Score x number of items on the measure)/Number of items that were actually answered
            </p>
            <p>
               If the result is a fraction, round to the nearest whole number.
            </p>
            <p>
               <strong>Frequency of Use</strong>
            </p>
            <p>
               To track change in the severity of the individual's repetitive thoughts and behavior over time, the measure
               may be completed at regular intervals as clinically indicated, depending on the stability of the individual's
               symptoms and treatment status. For individuals of impaired capacity, it is preferred that completion of the
               measure at follow-up appointments is by the same knowledgeable informant. Consistently high scores on the
               measure may indicate significant and problematic areas for the individual that might warrant further
               assessment, treatment, and follow-up. Your clinical judgment should guide your decision.
            </p>
         </div>
      </form>
   )
}